var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUserCircle = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9999 9.5999C8.9999 7.94305 10.343 6.5999 11.9999 6.5999C13.6568 6.5999 14.9999 7.94305 14.9999 9.5999C14.9999 11.2568 13.6568 12.5999 11.9999 12.5999C10.343 12.5999 8.9999 11.2568 8.9999 9.5999ZM11.9999 7.7999C11.0058 7.7999 10.1999 8.60579 10.1999 9.5999C10.1999 10.594 11.0058 11.3999 11.9999 11.3999C12.994 11.3999 13.7999 10.594 13.7999 9.5999C13.7999 8.60579 12.994 7.7999 11.9999 7.7999Z",
    fill: "#1BB92C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3999 11.9999C3.3999 7.25025 7.25025 3.3999 11.9999 3.3999C16.7496 3.3999 20.5999 7.25025 20.5999 11.9999C20.5999 16.7496 16.7496 20.5999 11.9999 20.5999C7.25025 20.5999 3.3999 16.7496 3.3999 11.9999ZM11.9999 4.5999C7.913 4.5999 4.5999 7.913 4.5999 11.9999C4.5999 14.0364 5.42252 15.8807 6.75359 17.2187C6.8979 16.4402 7.18145 15.7062 7.7506 15.116C8.60192 14.2331 9.96323 13.7999 11.9999 13.7999C14.0365 13.7999 15.3978 14.2331 16.2491 15.116C16.8183 15.7062 17.1018 16.4403 17.2462 17.2188C18.5773 15.8808 19.3999 14.0364 19.3999 11.9999C19.3999 7.913 16.0868 4.5999 11.9999 4.5999ZM16.1548 18.1242C16.0733 17.1547 15.8628 16.4441 15.3853 15.9489C14.8657 15.4101 13.903 14.9999 11.9999 14.9999C10.0967 14.9999 9.13399 15.4101 8.61442 15.9489C8.13692 16.4441 7.92639 17.1546 7.84488 18.1242C9.02938 18.9294 10.4597 19.3999 11.9999 19.3999C13.5401 19.3999 14.9704 18.9294 16.1548 18.1242Z",
    fill: "#1BB92C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UserCircle.89e2725b.svg";
export { ForwardRef as ReactComponent };